import styles from '@/modules/pipelines/components/deep-dive/pipeline-map-tabs.module.scss';
import { Button, Card, CardFooter, CardHeader, Col, Row } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { Page } from '@/shared/pagination/export';
import { Article, articleApi } from '@/modules/articles/export';
import dayjs, { Dayjs } from 'dayjs';

export default function PipelineAnalysisPanel() {
  const [articles, setArticles] = useState<Page<Article>>();
  const [bullets, setBullets] = useState<Page<Article>>();
  const [date, setDate] = useState<Dayjs>(dayjs());

  useEffect(() => {
    articleApi
      .getArticlesBySection(['us-gas-bullets', 'us-oil'], {
        limit: 12,
      })
      .then(setBullets);
  }, []);

  useEffect(() => {
    articleApi
      .getArticlesBySection(undefined, {
        includeGenres: ['mni-section:d-north-america-gas-fundamentals'],
        limit: 12,
        updatedAfter: date.startOf('day').valueOf(),
        updatedBefore: date.endOf('day').valueOf(),
      })
      .then(setArticles);
  }, [date]);

  return (
    <div className={styles.page}>
      <Row>
        <Col md={8}>
          <h3 className={'mb-3'}>Gas Daily Reports</h3>
          <div className={'d-flex justify-content-between mb-2'}>
            <Button
              variant={'outline-secondary'}
              size={'sm'}
              onClick={() => setDate(date.subtract(1, 'day'))}
            >
              Prev
            </Button>
            <span>{date.format('dddd, MMMM DD')}</span>
            <Button
              variant={'outline-secondary'}
              size={'sm'}
              disabled={date.isSame(dayjs().endOf('day'), 'day')}
              onClick={() => setDate(date.add(1, 'day'))}
            >
              Next
            </Button>
          </div>
          <Row>
            {articles &&
              articles.content.map(article => (
                <Col key={article.uri} md={6}>
                  <Card className={'mb-3'}>
                    <CardHeader>
                      <h4>{article.headline}</h4>
                    </CardHeader>
                    <CardFooter>
                      <p>{article.byline}</p>
                    </CardFooter>
                  </Card>
                </Col>
              ))}
          </Row>
        </Col>
        <Col md={4}>
          <h3 className={'mb-3'}>Live Updates</h3>

          {bullets?.content.map(bullet => (
            <div className={'mb-3'}>
              <div className={'border-bottom'}>
                <h4>{bullet.headline}</h4>
              </div>
            </div>
          ))}
        </Col>
      </Row>
    </div>
  );
}
